module.exports = __webpack_public_path__ + "img/hardness.f4b6f9f.webp";